var _ = require('ES/lib/lodash');

module.exports = function(event, Displaylists){
	if (event && event.is_mp_event && Displaylists && Displaylists.perspeaker) {//make sure Displaylists are loaded before we check, otherwise it will always result in needing to sign
		var num_signed = _.filter(Displaylists.perspeaker, function (speaker) {
			return speaker.flags.accepted_mp_agreement;
		}).length;
		if (num_signed === 0) {
			return true;//needs to sign
		}
	}
	return false;
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/needsToSignMPAgreementFirst.js